module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-research-bg.354b76d4.png";